import React, { Component } from 'react';
import { Helmet } from 'react-helmet';

import DesktopResponsive from '../responsive/Pricing/DesktopResponsive';
import MobileResponsive from '../responsive/Pricing/MobileResponsive';

class Pricing extends Component {
  render() {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" />
          <title>EditPage Pricing | Free, Growth, Scale, Enterprise</title>
          <meta
            content="Start on Free, then upgrade to Growth, Scale, or Enterprise with predictable pricing and clear feature upgrades at every stage."
            name="description"
          />
          <meta
            property="og:title"
            content="EditPage Pricing | Free, Growth, Scale, Enterprise"
          />
          <meta
            property="og:description"
            content="Start on Free, then upgrade to Growth, Scale, or Enterprise with predictable pricing and clear feature upgrades at every stage."
          />
          <meta
            name="twitter:title"
            content="EditPage Pricing | Free, Growth, Scale, Enterprise"
          />
          <meta
            name="twitter:description"
            content="Start on Free, then upgrade to Growth, Scale, or Enterprise with predictable pricing and clear feature upgrades at every stage."
          />
          <link rel="canonical" href="https://www.editpage.com/pricing" />
        </Helmet>
        <DesktopResponsive history={this.props.history} />
        <MobileResponsive history={this.props.history} />
      </div>
    );
  }
}

export default Pricing;
